import { useState } from 'react';
import { Button, Checkbox, Header, Modal, Table } from 'semantic-ui-react';
import { DescriptorCleanedLabel, ImportDescriptorIdType } from '../../../../types';
import { useImportTableStoreDescriptorsMap } from '../../context/importTableContext';
import './styles.css';
import { getCleanedLabels } from './utils';
import { IMPORT_DESCRIPTOR_SOURCE } from '../../../../constants/generalConstants';

type LabelNormalizationModalPropsType = {
    open: boolean;
    closeModal: () => void;
    onConfirm: (cleanCandidates: DescriptorCleanedLabel[]) => void;
};

function LabelNormalizationModal({ closeModal, onConfirm, open }: LabelNormalizationModalPropsType) {
    const descriptorsMap = useImportTableStoreDescriptorsMap();
    const nonMasterTableDescriptors = Object.values(descriptorsMap).filter(
        (d) => d.source !== IMPORT_DESCRIPTOR_SOURCE.MASTER_TABLE
    );
    const [descriptorsWithDiffs, setDescriptorsWithDiffs] = useState<DescriptorCleanedLabel[]>(() =>
        getCleanedLabels(nonMasterTableDescriptors)
    );

    const handleToggleInclude = (descriptorId: ImportDescriptorIdType) => {
        setDescriptorsWithDiffs((prev) => {
            return prev.map((d) => {
                if (d.descriptorId === descriptorId) {
                    return { ...d, include: !d.include };
                }
                return d;
            });
        });
    };

    return (
        <Modal size="small" open={open} onClose={closeModal}>
            <Modal.Header>Normalized Labels</Modal.Header>
            <Modal.Content>
                {!!descriptorsWithDiffs.length ? (
                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Differences</Table.HeaderCell>
                                <Table.HeaderCell>New Value</Table.HeaderCell>
                                <Table.HeaderCell>Accept</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {descriptorsWithDiffs.map((d) => {
                                const highlightedLabel = d.highlightedLabel;
                                const cleanedLabel = d.cleanLabel;
                                return (
                                    <Table.Row key={d.descriptorId}>
                                        <Table.Cell>
                                            {highlightedLabel.length ? (
                                                <>{highlightedLabel.map((labelPart) => labelPart)}</>
                                            ) : (
                                                cleanedLabel
                                            )}
                                        </Table.Cell>
                                        <Table.Cell>{cleanedLabel}</Table.Cell>
                                        <Table.Cell textAlign="center">
                                            <Checkbox
                                                checked={d.include}
                                                onChange={() => handleToggleInclude(d.descriptorId)}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })}
                        </Table.Body>
                    </Table>
                ) : (
                    <Header>There are no labels for normalization</Header>
                )}
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={() => onConfirm(descriptorsWithDiffs.filter((d) => d.include))}>
                    APPLY
                </Button>
                <Button secondary onClick={closeModal}>
                    CANCEL
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default LabelNormalizationModal;
